<template>
    <div class="rule">
        <div class="imgBox" @click="changeIsShow">
            <img v-if="isShow" src="./../assets/usercenter/rule-unchecked.png" alt="">
            <img else src="./../assets/usercenter/rule-checked.png" alt="">
        </div>
        <div>
            <p class="text">本人已阅读并同意<router-link to="/home/outside/rule" tag="span">《用户协议》</router-link></p>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return {
            isShow : true,
        }
    },
    methods:{
        changeIsShow(){
            this.isShow = !this.isShow
            this.$emit("status",this.isShow);
        }
    }
}

</script>
<style lang="scss" scoped>
    .rule{
        width:100%;
        display: flex;
        justify-content: center;
        align-items:center;
        .imgBox{
            width:.14rem;
            height:.14rem;
            overflow: hidden;
        }
        .text{
            font-size: .14rem;
            color:#555;
            span{
                font-size: 12px;
                color:#9EA5AA;
            }
        }
    }

</style>
